var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.71429C0 0.767512 0.767512 0 1.71429 0H28.2857C29.2325 0 30 0.767512 30 1.71429V28.2857C30 29.2325 29.2325 30 28.2857 30H1.71429C0.767512 30 0 29.2325 0 28.2857V1.71429Z",
    fill: "#292828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2319 9.69653H17.9462V11.4644H13.2319V9.69653Z",
    stroke: "#FF8F01",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2319 14.116H19.1248V15.8838H13.2319V14.116Z",
    stroke: "#FF8F01",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2319 18.5356H20.8926V20.3035H13.2319V18.5356Z",
    stroke: "#FF8F01",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2856 11.1695C10.611 11.1695 10.8749 10.9057 10.8749 10.5803C10.8749 10.2548 10.611 9.99097 10.2856 9.99097C9.96012 9.99097 9.69629 10.2548 9.69629 10.5803C9.69629 10.9057 9.96012 11.1695 10.2856 11.1695Z",
    stroke: "#FF8F01",
    strokeWidth: 0.857143
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2856 15.5892C10.611 15.5892 10.8749 15.3254 10.8749 14.9999C10.8749 14.6745 10.611 14.4106 10.2856 14.4106C9.96012 14.4106 9.69629 14.6745 9.69629 14.9999C9.69629 15.3254 9.96012 15.5892 10.2856 15.5892Z",
    stroke: "#FF8F01",
    strokeWidth: 0.857143
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2856 20.0089C10.611 20.0089 10.8749 19.7451 10.8749 19.4196C10.8749 19.0942 10.611 18.8303 10.2856 18.8303C9.96012 18.8303 9.69629 19.0942 9.69629 19.4196C9.69629 19.7451 9.96012 20.0089 10.2856 20.0089Z",
    stroke: "#FF8F01",
    strokeWidth: 0.857143
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.956324937621ba672c96faa67527c219.svg";
export { ForwardRef as ReactComponent };